import { cn } from '@/utils/cn';

/** The approved native Project P mark, exported from the shared Figma component. */
export default function BrandLogo({
  compact = false,
  className,
}: {
  compact?: boolean;
  className?: string;
}) {
  return (
    <span
      role="img"
      aria-label="Projects by AA Health logo"
      className={cn('brand-lockup', compact && 'brand-lockup-compact', className)}
    >
      <img src="/brand/project-p.png" alt="" className="brand-mark" width="40" height="40" />
      {!compact && (
        <span className="brand-wordmark" aria-hidden="true">
          <span className="brand-product">Projects</span>
          <span className="brand-parent">by AA Health</span>
        </span>
      )}
    </span>
  );
}
